import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Dumbbell, Apple, Video, Users } from 'lucide-react';

const Services = () => {
  const services = [
    {
      icon: <Dumbbell size={40} />,
      title: 'Trening Personalny',
      description: 'Indywidualnie dopasowane treningi pod Twoje cele i możliwości. Profesjonalne wsparcie i motywacja na każdym kroku.',
      price: 'od 80 zł',
      features: [
        'Plan treningowy dopasowany do Ciebie',
        'Nadzór techniki wykonania ćwiczeń',
        'Motywacja i wsparcie trenera',
        'Elastyczne godziny treningów'
      ]
    },
    {
      icon: <Apple size={40} />,
      title: 'Dietetyka',
      description: 'Spersonalizowane plany żywieniowe oparte na Twoich celach, preferencjach i stylu życia.',
      price: 'Indywidualna wycena',
      features: [
        'Analiza składu ciała',
        'Spersonalizowany plan żywieniowy',
        'Porady i wsparcie dietetyczne',
        'Dostosowanie diety do Twojego stylu życia'
      ]
    },
    {
      icon: <Video size={40} />,
      title: 'Treningi Online',
      description: 'Profesjonalne wsparcie bez względu na to, gdzie się znajdujesz. Treningi online z pełnym doradztwem.',
      price: 'Elastyczne pakiety',
      features: [
        'Treningi przez video call',
        'Plan treningowy do domu/siłowni',
        'Bieżący kontakt z trenerem',
        'Dostęp do materiałów edukacyjnych'
      ]
    },
    {
      icon: <Users size={40} />,
      title: 'Doradztwo Osobiste',
      description: 'Kompleksowe wsparcie w osiąganiu Twoich celów - trening, dieta i motywacja w jednym pakiecie.',
      price: 'Indywidualna wycena',
      features: [
        'Holistyczne podejście do zdrowia',
        'Regularne konsultacje',
        'Wsparcie motywacyjne',
        'Pomoc w budowaniu nawyków'
      ]
    }
  ];

  return (
    <section className="services-section" id="services">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Moje Usługi</h2>
          <p className="section-description">
            Oferuję kompleksowe wsparcie w osiąganiu Twoich celów fitness
          </p>
        </div>
        <div className="services-grid">
          {services.map((service, index) => (
            <Card key={index} className="service-card">
              <CardHeader>
                <div className="service-icon">{service.icon}</div>
                <CardTitle className="service-title">{service.title}</CardTitle>
                <div className="service-price">{service.price}</div>
              </CardHeader>
              <CardContent>
                <CardDescription className="service-description">
                  {service.description}
                </CardDescription>
                <ul className="service-features">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="service-feature">
                      <span className="feature-bullet">•</span>
                      {feature}
                    </li>
                  ))}
                </ul>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
